import {getDeviceType} from "../plugins/Helpers";
import {createApp, ref} from "vue";
import {SurveyModal} from "@webstacz/shop-components";
import i18n from "../plugins/i18n";

document.addEventListener('DOMContentLoaded', () => {
    const surveyDiv = document.getElementById('hear-survey');
    if (surveyDiv !== null) {
        const el = document.createElement('div');
        document.querySelector('main').append(el);

        const surveyOptions = JSON.parse(surveyDiv.getAttribute('data-survey-options'));
        const orderId = surveyDiv.getAttribute('data-order-id');

        const app = createApp({
            components: {
                SurveyModal,
            },
            template: `
                <SurveyModal
                    v-model="showModal"
                    :survey-options="surveyOptions"
                    @surveySubmitted="onSurveySubmitted"
                />
            `,
            setup() {
                const showModal = ref(true);

                const onSurveySubmitted = (survey) => {
                    window.beacon.add(
                        'order.survey',
                        {
                            entity: {
                                type: 'order',
                                id: orderId,
                            },
                            order_id: orderId,
                            answer: survey,
                            lead_device_category: getDeviceType(),
                            lead_product_category: window.analytics_label,
                        }
                    );
                    window.beacon.send();
                };

                return {
                    showModal,
                    surveyOptions,
                    onSurveySubmitted,
                };
            },
        });

        app.use(i18n);
        app.mount(el);
    }
});
